/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

import getCurrentMediaQuery from '../helpers/_getCurrentMediaQuery';

/* ====================================================================
   BEHAVIOURS —> FADE ACCORDION
   ==================================================================== */

const accordion = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'accordion',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
    toggleContent(el) {
      console.log(el);

      // if this accordion is already open
      if (el.classList.contains('is-open')) {
        // console.log('contains is open');
        el.classList.remove('is-open');
      } else {
        // console.log('doesnt contain is open');

        // Close any open accoridons
        const openAccordion = this.node.querySelector('.c-accordion-item.is-open');

        if (openAccordion) {
          openAccordion.classList.remove('is-open');
        }

        el.classList.toggle('is-open');
      }
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      // console.log(this.name + ':', this);

      const accordionEls = this.node.querySelectorAll('.c-accordion-item');

      console.log(accordionEls);

      const self = this;

      accordionEls.forEach((el) => {
        el.addEventListener('click', function () {
          self.toggleContent(el);
        });
      });
    },
  },
);

export default accordion;
